<template>
    <div class="step-marker">
        <div
            v-for="(label, i) in steps"
            :key="i"
            class="step"
            :class="statusClass(i)"
        >
            <div
                v-if="i > 0"
                class="connector"
                :class="{ done: i <= activeIndex }"
            ></div>
            <div class="circle">
                <span v-if="i < activeIndex" class="check">&#10003;</span>
                <span v-else>{{ i + 1 }}</span>
            </div>
            <div class="label">{{ label }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepMarker",
        props: {
            steps: {
                type: Array,
                required: true,
                validator: v => Array.isArray(v) && v.length >= 2
            },
            current: {
                type: Number,
                required: true
            }
        },
        computed: {
            activeIndex() {
                const last = this.steps.length - 1;
                if (this.current < 0) return 0;
                if (this.current > last) return last;
                return this.current;
            }
        },
        methods: {
            statusClass(i) {
                if (i < this.activeIndex) return 'done';
                if (i === this.activeIndex) return 'current';
                return 'todo';
            }
        }
    }
</script>

<style scoped>
    .step-marker {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        max-width: 480px;
        margin: 0 auto 24px auto;
        padding: 0 8px;
    }

    .step {
        position: relative;
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 0;
    }

    .connector {
        position: absolute;
        top: 15px;
        right: 50%;
        width: 100%;
        height: 2px;
        background-color: #e1e1e1;
        z-index: 0;
    }

    .connector.done {
        background-color: #fada28;
    }

    .circle {
        position: relative;
        z-index: 1;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        border: 2px solid #e1e1e1;
        background-color: #ffffff;
        color: #999999;
        box-sizing: border-box;
    }

    .step.done .circle {
        background-color: #fada28;
        border-color: #fada28;
        color: #000000;
    }

    .step.current .circle {
        background-color: #22753a;
        border-color: #22753a;
        color: #ffffff;
    }

    .check {
        font-size: 16px;
        line-height: 1;
    }

    .label {
        margin-top: 8px;
        font-size: 12px;
        text-align: center;
        color: #999999;
        word-break: break-word;
    }

    .step.current .label {
        color: #22753a;
        font-weight: 600;
    }

    .step.done .label {
        color: #333333;
    }
</style>
